import { QIcon_globe } from '@repo/icons/index'
import router from 'next/router'
import { useEffect, useRef, useState } from 'react'
import { GTM_CLICK_EVENT, getEventUserType, sendGTMCustomClickEvent } from '../../../../helpers/gtmHelper'
import { useChangeLocale } from '../../../../modules/apis/common/user'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import {
  LOCALE_EN,
  LOCALE_JA,
  LOCALE_KO,
  LOCALE_ZH_CHS,
  LOCALE_ZH_CHT,
  LocaleType,
} from '../../../../modules/i18n/config'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { STUDENT_BTN_ID } from '../../../../modules/ids/gtm/student'
import { COLORS } from '../../../../modules/vars'
import { FeatherChevronDown, FeatherChevronUp } from '../../../common/Icons'

const LanguageList = () => {
  const [isLanguagePanelOpen, setIsLanguagePanelOpen] = useState(false)

  const dropdownRef = useRef<HTMLDivElement>(null)

  const { currentUser } = useCurrentUser()
  const { updateLandingLocale } = useTranslation()
  const { mutate } = useChangeLocale()

  const onClickLanguage = (locale: LocaleType, localeStr: string) => {
    sendGTMCustomClickEvent(
      GTM_CLICK_EVENT.CLICK_LANDING_BUTTON,
      STUDENT_BTN_ID.CLICK_MENU_CHANGE_LANG,
      `언어변경 - ${localeStr}`,
      getEventUserType(currentUser),
      `${router.asPath.substring(1).split('/').join('-')}}`,
      router.asPath
    )

    if (currentUser) {
      mutate({ locale })
    } else {
      updateLandingLocale(locale)
    }

    setIsLanguagePanelOpen(false)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsLanguagePanelOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <>
      {/* Language Section */}
      <div className="relative mr-[4px] z-[1000]" ref={dropdownRef}>
        <button
          className="flex items-center justify-start space-x-4"
          onClick={() => setIsLanguagePanelOpen((prev) => !prev)}
        >
          <QIcon_globe width={20} height={20} color={COLORS.GRAY500} />
          {isLanguagePanelOpen ? (
            <FeatherChevronUp className="text-gray-500" />
          ) : (
            <FeatherChevronDown className="text-gray-500" />
          )}
        </button>

        {isLanguagePanelOpen && (
          <div className="absolute top-[28px] left-0 min-w-[135px] space-y-[4px] rounded-[7px] bg-white p-[8px] shadow-[0_2px_8px_8px_rgba(0,0,0,0.15)]">
            <button
              className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
              onClick={() => onClickLanguage(LOCALE_KO, '한국어')}
            >
              한국어
            </button>
            <button
              className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
              onClick={() => onClickLanguage(LOCALE_EN, 'English')}
            >
              English
            </button>
            <button
              className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
              onClick={() => onClickLanguage(LOCALE_ZH_CHS, '중국어(간체)')}
            >
              中文（简体）
            </button>
            <button
              className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
              onClick={() => onClickLanguage(LOCALE_ZH_CHT, '중국어(번체)')}
            >
              中文（繁體）
            </button>
            <button
              className="Body2-14Md block w-full rounded-[4px] p-[12px] text-left hover:bg-purple-50 hover:text-purple-500"
              onClick={() => onClickLanguage(LOCALE_JA, '일본어')}
            >
              日本語
            </button>
          </div>
        )}
      </div>
    </>
  )
}
export default LanguageList
